export default "__VITE_ASSET__MmGTccgz__"